
<Modal :mayCancel="true" v-on:done="onDone" v-on:cancel="onDone">
  <form
    class="EditBoard_Form PForm"
    v-on:click.stop
    v-on:submit.prevent="onDone"
  >
    <p>
      <label for="name">Board Name</label>
      <input name="name" type="text" v-model="name" />
    </p>
    <p>
      <label class="m-inline" for="isTemplate">
        This board is a template
      </label>
      <input name="isTemplate" type="checkbox" v-model="isTemplate" />
    </p>
  </form>
  <div class="ButtonRow_Right">
    <button class="WBMBigButton m-primary" v-on:click="onDone">Done</button>
  </div>
</Modal>
